/**
 * Checks if a value is a plain object structure.
 * Returns true for {} or { key: 'value' },
 * but false for null, arrays, functions, or built-in classes like Date.
 */
const isRecord = (value: unknown): value is Record<string, unknown> => {
  return (
    value !== null &&
    typeof value === "object" &&
    Array.isArray(value) === false
  );
};

export default isRecord;
